import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableGamesPerformanceReportsView.
 * @extends JetView
 */
export default class TableGamesPerformanceReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: 'datatable', // ID for the datatable
                            view: 'datatable', // Webix datatable component
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    width: 200, // Column width
                                    format: dateFormat, // Date format for the column
                                },
                                {
                                    id: 'GameName',
                                    header: _('Nombre del Juego'),
                                    width: 350,
                                },
                                {
                                    id: 'TypeGame',
                                    header: _('Tipo'),
                                    width: 200,
                                },
                                {
                                    id: 'ReturnPercentage',
                                    header: _('% Retorno real'),
                                    format: percentFormat, // Use percentFormat for this column
                                    width: 200,
                                },
                                {
                                    id: 'TotalBets',
                                    header: _('Total Apuesta'),
                                    width: 200,
                                },
                                {
                                    id: 'TotalBonusBet',
                                    header: _('Total apuestas por bonificación'),
                                    width: 250,
                                },
                                {
                                    id: 'TotalAward',
                                    header: _('Total de premios'),
                                    width: 200,
                                },
                                {
                                    id: 'TotalBonusPrizes',
                                    header: _('Total de premios por bonificación'),
                                    width: 250,
                                },
                                {
                                    id: 'TotalBetsVoided',
                                    header: _('Total de apuestas anuladas'),
                                    width: 250,
                                },
                                {
                                    id: 'TotalReturns',
                                    header: _('Total de devoluciones'),
                                    width: 200,
                                },
                            ],
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event triggered after data is loaded.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            /**
                             * Event triggered when the datatable is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no records
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data message
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable math operations in the datatable
                            datafetch: 10, // Number of records to fetch at a time
                            pager: 'pagerA', // ID of the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + 'es/Financial/GetGamesPerformance'; // API endpoint for fetching data

        /**
         * Event listener for filtering data based on user input.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'gamesPerformance:filter', (filterData) => {
            let object = Object.entries(filterData); // Convert filterData to entries
            let string1 = ''; // Initialize query string

            for (let i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        let date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                let date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        let object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    let d = new Date(object2[j][1]); // Create date object from start
                                    let dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        let d = new Date(object2[j][1]); // Create date object from end
                                        let dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$('consultDesk').define('disabled', true); // Disable consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1) // Load data with constructed query string
                .then((response) => {
                    $$('consultDesk').define('disabled', false); // Enable consult desk after loading
                })
                .catch((e) => {
                    $$('consultDesk').define('disabled', false); // Enable consult desk on error
                });
            $$('filterPopup').hide(); // Hide filter popup
        });

        $$('pagerA').attachEvent('onAfterPageChange', function (page) {
            webix.delay(
                function () {
                    if (page != '0') {
                        chargeTable(); // Load data for the new page
                    }
                },
                '',
                '',
                100,
            );
        });

        /**
         * Event listener for resizing the view.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'changeSize', (filterData) => {
            chargeTable(); // Reload table data on size change
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get page size
            let page = grid.getPage(); // Get current page
            let first = size * page; // Calculate the starting index
            let last = first + size - 1; // Calculate the ending index
            grid.load(url + '?start=' + first + '&count=' + (last + 1) + filter); // Load data with pagination
        }
    }
}

// FILE DOCUMENTED
